import React, { useEffect, useState } from 'react';
import Nav from '../components/Nav';
import Footer from '../components/Footer';
import projectlogo from '../images/logo_white.png';
import client from '../contenful/client';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import Projectlib from './Projectlib';
import "../pages/Project.css";
import logo2 from "../images/logo2.png";
import logo3 from "../images/logo3.png";
import logo4 from "../images/logo4.png";

const ProjectDetail = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { slug } = useParams(); // ✅ Get slug from URL
  const { project, allProjects } = location.state || {};

  const [currentProject, setCurrentProject] = useState(project);
  const [projectDetailsList, setProjectDetailsList] = useState([]);
  const [currentProjectEntry, setCurrentProjectEntry] = useState(null);
  const [loadingDetails, setLoadingDetails] = useState(true);
  const [randomProjects, setRandomProjects] = useState([]);
  const [loadingRandom, setLoadingRandom] = useState(true);
  const logoimg = [logo2, logo3, logo4];

  // Update current project when location state changes
  useEffect(() => {
    if (location.state?.project) {
      setCurrentProject(location.state.project);
    }
  }, [location.state?.project]);

  // Fetch all project entries from Contentful
  useEffect(() => {
    const fetchData = async () => {
      try {
        const entries = await client.getEntries({ content_type: "projectdetails" });
        setProjectDetailsList(entries.items);
        setLoadingDetails(false);
      } catch (err) {
        console.error("Error fetching project details:", err);
        setLoadingDetails(false);
      }
    };

    if (currentProject) {
      fetchData();
      window.scrollTo(0, 0);
    }
  }, [currentProject]);

  // Find current project entry from fetched list
  useEffect(() => {
    if (currentProject) {
      const projectDetailId = currentProject.fields.projectDetailRef?.sys?.id;
      const matchedProject = projectDetailsList.find(
        item => item.sys.id === projectDetailId
      );
      setCurrentProjectEntry(matchedProject || null);
    }
  }, [currentProject, projectDetailsList]);

  // Shuffle helper
  const shuffleArray = (array) => {
    const shuffled = [...array];
    for (let i = shuffled.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }
    return shuffled;
  };

  // Get random 6 projects excluding current
  useEffect(() => {
    if (!allProjects || allProjects.length === 0 || !currentProject) return;

    const filteredProjects = allProjects.filter(p => p.sys.id !== currentProject.sys.id);
    const shuffledProjects = shuffleArray(filteredProjects);
    setRandomProjects(shuffledProjects.slice(0, 6));
    setLoadingRandom(false);
  }, [allProjects, currentProject]);

  if (!currentProject || !currentProjectEntry) {
    return <div className="error">Project not found. Please go back and select a project.</div>;
  }

  const item = currentProjectEntry;

  // Parse sections safely
  const mainImages = item.fields.mainImage?.map(img => ({
    image: `https:${img.fields.file.url}`,
    title: img.fields.title || "No Title",
    description: img.fields.description || "No Description"
  })) || [];

  const rows = [item.fields.rowtitle1, item.fields.rowtitle2, item.fields.rowtitle3].filter(Boolean);

  const sec2Images = item.fields.sec2Image?.map(img => ({
    image: `https:${img.fields.file.url}`
  })) || [];

  const galleryImages = item.fields.imagesGallery?.map(img => ({
    image: `https:${img.fields.file.url}`
  })) || [];

  const drawings = item.fields.drawings?.map(img => ({
    image: `https:${img.fields.file.url}`
  })) || [];

  return (
    <div className="project-det-sec">
      <Nav logo={projectlogo} logoSize="300px" className="static-nav" />

      <div className="pro-Main">
        {mainImages.map((main, index) => (
          <div key={index} className="main-image-card">
            <img src={main.image} alt={main.title} className="main-img" loading="lazy" />
            <div className="main-content">
              <h2 className="main-title">{main.title}</h2>
              <p className="main-desc">{main.description}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="project-Num">
        {rows.map((row, i) => (
          <div className="pro-col" key={i}>
            <div className="circle-icon">
              <img src={logoimg[i]} alt="icon" loading="lazy" />
            </div>
            <h2>
              <span className="big-text">{row?.[0] || ''}</span>
              <span className="small-text">{row?.[1] || ''}</span>
            </h2>
          </div>
        ))}
      </div>
      <hr />

      <div className="proDet-sec2">
        {sec2Images.map((img, index) => (
          <img key={index} src={img.image} alt="Section 2" className="sec2-img" loading="lazy" />
        ))}
      </div>

      <div className="proDet-sec3">
        <div className="pro-sec3-left">
          <p className="left1">{item.fields.sec3Para1}</p>
          <p className="left2">{item.fields.sec3Para2}</p>
        </div>
        <div className="pro-sec3-right">
          <p>{item.fields.sec3Para3}</p>
        </div>
      </div>

      <div className="img_gall_container">
        <div className="img_gall">
          {galleryImages.map((img, index) => (
            <img key={index} src={img.image} alt={`Gallery ${index}`} loading="lazy" />
          ))}
        </div>
      </div>

      <div className="Drawings">
        <h1>Drawings</h1>
        <svg width="10%" height="3">
          <line x1="0" y1="0" x2="100%" y2="0" stroke="black" strokeWidth="2" />
        </svg>

        <div className="Drawings-container">
          {drawings.map((img, index) => (
            <img key={index} src={img.image} alt={`Drawing ${index}`} className="gall-img" loading="lazy" />
          ))}
        </div>
      </div>

      {/* Random Projects Section */}
      <div className="random-projects">
        <h2>Other Projects</h2>
        <Projectlib limit={6} allProjects={randomProjects} currentSlug={slug} /> 
        {/* ✅ pass slug from URL */}
      </div>

      <Footer />
    </div>
  );
};

export default ProjectDetail;
